import { compact } from 'fp-ts/lib/Array';
import { IndexFilter } from './IndexFilter';
import { IndexFilters_ControlsState, IndexFilters_Snapshot } from './types/indices.type';

export class IndexFiltersSnapshot {
    private indexFilter: IndexFilter;

    constructor() {
        this.indexFilter = new IndexFilter();
    }

    public includeSetInSnapshot(indicesControls: IndexFilters_ControlsState): boolean {
        return indicesControls.filter(this.indexFilter.includeInSnapshot).length > 0;
    }

    public createSnapshotFromState(indicesControls: IndexFilters_ControlsState): IndexFilters_Snapshot {
        return compact(indicesControls.map(this.indexFilter.createSnapshotFromState));
    }

    public createStateFromSnapshot(
        snapshot: IndexFilters_Snapshot,
        indicesControls: IndexFilters_ControlsState
    ): IndexFilters_ControlsState {
        return indicesControls.map((index) => {
            const snapshotIndex = snapshot.find((snapshotIndex) => snapshotIndex === index.identifier);

            if (snapshotIndex) {
                return {
                    ...index,
                    isChecked: true,
                };
            }
            return index;
        });
    }
}
